










import { Component, Vue } from 'vue-property-decorator';
import Header from '@/components/common/Header.vue';
import Footer from '@/components/common/Footer.vue';
import ActionReportSearchContent from '@/components/action_report_search/ActionReportSearchContent.vue';

@Component({
  components: {
    Header,
    ActionReportSearchContent,
    Footer,
  },
})
export default class GlobalSearch extends Vue {}
